const apiKey = 'VkVyuDpUJidEY7Y/dr2ZSQ==hG3b9Y2vbCn48P6D';

export default apiKey;
